import src from "IMAGE";
export default { src, width: 440, height: 86, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AApKkqUFKk1VBQYTTAcHGW8HBxhlBAQQPQQEDjEEBA4yAAdBanUHMGh1AwQNJQUFETkEBBA1AwMNJQQEDSUDAwwfUXoIhAmhfO8AAAAASUVORK5CYII="};
